<template>
      <div no-body class="lku-adv"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col lg="9">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=1 label="Filter">
              <b-row>
                <b-col class="pr-1" cols="3"><b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" size="sm" placeholder="Settle.Number"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="4"><b-form-input v-model="tblData.crewinfo" @keyup.13.native="refresh()" size="sm" placeholder="Settled By"></b-form-input></b-col>
                <b-col class="pl-1 pr-1" cols="5"><b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" size="sm" placeholder="Description" ></b-form-input></b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group style="margin-bottom:-4px !important;" label-cols=3 >
              <b-row>
                <b-button class="btn btn-success mr-1" @click="refresh()" size="sm"> <i class="fa fa-search"></i> Search</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear</b-button>
              </b-row>
          </b-form-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblAdvSetCr"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          @row-clicked="selectItem"
        >
          <template v-slot:cell(jumlah)="data">
            {{data.item.matauang}} {{data.item.jumlah | numFormat}}
          </template>
          <template v-slot:cell(outstand)="data">
            {{data.item.outstand | numFormat('0,0.00')}}
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      </div>
</template>
<style lang="scss">
  .lku-adv {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import advsettle from "../../apis/advsettle";

export default {
  data() {
    return {
      items:[],
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trx. Number",
            sortable: true
          },
          {
            key: "keterangan",
            label: "Description",
          },
          {
            key: "nomorAdv",
            label: "Adv. Request#",
            sortable: true
          },
          {
            key: "crewinfo",
            label: "Settled By",
            sortable: true
          },
          {
            key: "jumlah",
            label: "Settled Amt.",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "outstand",
            label: "Outstanding",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right"
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'nomor',
        sortDesc: false,
        outstand:'3'
      },
      lkuLoading:false
    };
  },
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    // },
    // data: async function() {
    //   this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

    //   const list = await advsettle.list(this.tblData);          
    //   return list;
    // },

    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.crewinfo=  '';
        this.refresh();
    },    
    refresh: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading=true;
      this.items= await advsettle.list(this.tblData);    
      this.lkuLoading=false;
      this.$refs.tblAdvSetCr.refresh();
    }
  }
};
</script>
